import { useState } from "react";
import { Card, CardHeader, Text, makeStyles, Caption1, Button } from "@fluentui/react-components";
import { DismissRegular } from "@fluentui/react-icons";
import { IOneDriveCardProps } from "./onedrive-card.props";

const layoutStyles = makeStyles({
    image: {
        width: '28px'
    },
    textWrapper: {
        overflow: 'hidden',
        display: 'inline-grid',
        '> span': {
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }
    }
});

export default function OneDriveCard(props: IOneDriveCardProps) {
    const styles = layoutStyles();

    const [iconUrl, setIconUrl] = useState<string>("images/OneDriveLogo.svg");

    if (!props.item)
        return (<></>);

    const onClick = () => {
        console.log(`OneDriveCard -> onClick -> `, props.item);
        if (props.onSelect && props.item)
            props.onSelect(props.item);
    }

    const onDismissClick = () => {
        console.log(`OneDriveCard -> onDismissClick -> `, props.item);
        if (props.onDismissClick && props.item)
            props.onDismissClick(props.item);
    }

    return (
        <Card onClick={props.onSelect ? onClick : undefined} appearance={props.style}>
            <CardHeader
                image={<img className={styles.image} src={iconUrl} />}
                header={<div className={styles.textWrapper}><Text as="span">{props.item.title}</Text></div>}
                description={<div className={styles.textWrapper}><Caption1 as="span">{props.item.owner}</Caption1></div>}
                action={props.onDismissClick && <Button onClick={onDismissClick} appearance="subtle" icon={<DismissRegular />} />}
            />
        </Card>
    );
}